import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface GridImagelessIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: GridImagelessIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["url", "headline"]);
}
